import React from "react";
import PredictionForm from "./Form";

function User() {
  return (
    <>
      <head>
        <title>HomePage</title>
      </head>
      <div className="usercontainer">
        <PredictionForm />
      </div>
    </>
  );
}

export default User;
